module.exports = __webpack_public_path__ + "static/media/true-digital-field-glare.139dc4f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/trueDigital/true-digital-field-glare.png
// module id = 3584
// module chunks = 0